
import React from 'react';
import ReactDOM from 'react-dom/client';
import { injectSpeedInsights } from '@vercel/speed-insights';
import App from './App';
import { AppProvider } from './context/AppContext';
import './styles/forms.css';

// Initialize Vercel Speed Insights before the app mounts so page-load metrics are captured.
injectSpeedInsights();

const CHUNK_RELOAD_KEY = 'agm:chunk-reload-attempted';

window.addEventListener('vite:preloadError', (event) => {
  const hasRetried = window.sessionStorage.getItem(CHUNK_RELOAD_KEY) === '1';
  if (hasRetried) return;

  event.preventDefault();
  window.sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  window.location.reload();
});

window.addEventListener('load', () => {
  window.sessionStorage.removeItem(CHUNK_RELOAD_KEY);
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>
);
